import React, { useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
import {
  ContainerCreatePassword,
  BoxAuth,
  Title,
  Input,
  DivInp,
  ButtonSub,
  ContainerBtn,
} from './styles';
import iconView from '../../assets/images/icone_view.svg';
import iconEsconder from '../../assets/images/icone_esconder.svg';

import * as authService from '../../services/auth';

export const passwordRegex = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/;

function CreatePassword() {
  const { token } = useParams();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [view, setView] = useState(false);

  const history = useHistory();

  const createPassword = async () => {
    try {
      if (!passwordRegex.test(password)) {
        toastr.error(
          'Erro',
          'A senha deve ser composta de 1 caracter maiusculo, 1 minusculo e 1 número e conter pelo menos 6 caracteres'
        );
        return;
      }
      if (password !== confirmPassword) {
        toastr.error('Erro', 'As senhas devem ser iguais.');
        return;
      }
      await authService.createPassword(password, token);

      toastr.success('Sucesso', 'A senha foi criada');
      history.push('/');
    } catch (err) {
      toastr.error('Erro', 'Erro interno');
    }
  };

  return (
    <ContainerCreatePassword>
      <BoxAuth>
        <Title>Criação de Senha</Title>
        <DivInp>
          <span>Nova Senha:</span>
          <Input
            type={view ? 'text' : 'password'}
            placeholder="•••••••••••"
            onChange={(e) => setPassword(e.target.value)}
            maxLength="30"
          />
          <img
            src={view ? iconView : iconEsconder}
            onClick={() => setView(!view)}
            alt="iconView"
          />
        </DivInp>
        <DivInp>
          <span>Confirma Senha:</span>
          <Input
            type={view ? 'text' : 'password'}
            placeholder="•••••••••••"
            onChange={(e) => setConfirmPassword(e.target.value)}
            maxLength="30"
          />
          <img
            src={view ? iconView : iconEsconder}
            onClick={() => setView(!view)}
            alt="iconView"
          />
        </DivInp>
        <ContainerBtn>
          <span>Voltar</span>
          <ButtonSub onClick={createPassword}>próximo</ButtonSub>
        </ContainerBtn>
      </BoxAuth>
    </ContainerCreatePassword>
  );
}

export default CreatePassword;
